// All calendar data is German-only, so the wall-clock digits stored in
// the DB are Europe/Berlin time. `new Date("YYYY-MM-DDTHH:mm:ss")` would
// parse those digits in the browser's local timezone, which is wrong
// for any user not in CET and shifts by an hour across DST transitions.
//
// parseApiDateAsBerlin takes the wall-clock digits and packs them into a
// Date's *UTC fields*, so they round-trip as the same digits. The display
// layer (formatBerlinDate) then renders them back through Intl.DateTimeFormat
// with timeZone:'Europe/Berlin' — which prints them as-is. The user's
// local timezone is never consulted.

const API_DATE_RE =
  /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2}))?/;

export function parseApiDateAsBerlin(
  dateStr: string | null | undefined
): Date | null {
  if (!dateStr) return null;
  const m = dateStr.match(API_DATE_RE);
  if (!m) return null;
  const [, y, mo, d, h, mi, s = "0"] = m;
  return new Date(Date.UTC(+y, +mo - 1, +d, +h, +mi, +s));
}

export function formatBerlinDate(
  d: Date | null | undefined,
  pattern: "date" | "time" | "datetime" | "longDate"
): string {
  if (!d) return "";
  const opts: Intl.DateTimeFormatOptions =
    pattern === "time"
      ? { hour: "2-digit", minute: "2-digit", timeZone: "Europe/Berlin" }
      : pattern === "date"
      ? {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          timeZone: "Europe/Berlin",
        }
      : pattern === "longDate"
      ? {
          weekday: "long",
          day: "2-digit",
          month: "long",
          year: "numeric",
          timeZone: "Europe/Berlin",
        }
      : {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          timeZone: "Europe/Berlin",
        };
  return new Intl.DateTimeFormat("de-DE", opts).format(d);
}
